import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { RootLayout } from './layout/RootLayout';

const Home = lazy(() => import('./pages/Home').then((m) => ({ default: m.Home })));
const Preview = lazy(() => import('./pages/Preview').then((m) => ({ default: m.Preview })));
const Callback = lazy(() => import('./pages/Callback').then((m) => ({ default: m.Callback })));
const AccessDenied = lazy(() => import('./pages/AccessDenied').then((m) => ({ default: m.AccessDenied })));
const Health = lazy(() => import('./pages/Health').then((m) => ({ default: m.Health })));

export function App() {
  return (
    <HelmetProvider>
      <RootLayout>
        <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:survey_id/preview" element={<Preview />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/403" element={<AccessDenied />} />
            <Route path="/health" element={<Health />} />
          </Routes>
        </Suspense>
      </RootLayout>
    </HelmetProvider>
  );
}

export default App;
